
import { useEffect } from 'react'
import Select from 'react-select'
import { STPStatusTypeDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const STPUnitTypeDDL = (props) => {
    const { Status, setStatus, rowData, Flag } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
            // Flag: Flag,
        }
        dispatch(STPStatusTypeDDLAPI({ data }))
    }, [])

    const { STPStatusTypeData } = useSelector(state => state.STPStatusTypeDDL)

    useEffect(() => {
        handleSTPStatusTypeDDL()
    }, [STPStatusTypeData])

    const handleSTPStatusTypeDDL = () => {
        // console.log(DeptDDLDataa)
        if (STPStatusTypeData && STPStatusTypeData.table && STPStatusTypeData.table.length > 0) {
            let list = STPStatusTypeData.table.map((item, index) => ({
                value: item.m_stP_MachineryActionsID,
                label: item.actionName,
            }))
            setStatus({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_stP_MachineryActionsID : 0,
                Label: Flag === 'Update' ? rowData.actionName : "Select...",
            })
        }
        else {
            setStatus({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Status</b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: Status.ID, label: Status.Label }}
                onChange={(e) => {
                    e ?
                        setStatus({ ...Status, ID: e.value, Label: e.label })
                        :
                        setStatus({ ...Status, ID: 0, Label: "Select..." })

                }}
                options={Status.DDL}
            />
        </div>
    )
}